/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceUpdateRequest
 */
export interface WorkspaceUpdateRequest {
    /**
     * Updated name for the workspace
     * @type {string}
     * @memberof WorkspaceUpdateRequest
     */
    name: string;
    /**
     * Updated URL of the workspace avatar image
     * @type {string}
     * @memberof WorkspaceUpdateRequest
     */
    avatarUrl: string;
}

/**
 * Check if a given object implements the WorkspaceUpdateRequest interface.
 */
export function instanceOfWorkspaceUpdateRequest(value: object): value is WorkspaceUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function WorkspaceUpdateRequestFromJSON(json: any): WorkspaceUpdateRequest {
    return WorkspaceUpdateRequestFromJSONTyped(json, false);
}

export function WorkspaceUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
    };
}

export function WorkspaceUpdateRequestToJSON(json: any): WorkspaceUpdateRequest {
    return WorkspaceUpdateRequestToJSONTyped(json, false);
}

export function WorkspaceUpdateRequestToJSONTyped(value?: WorkspaceUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
    };
}

